import React, { useEffect, useRef } from 'react';

import { useOptionsControl } from '../hooks/useOptionsControl';
import { useOptions } from '../queries/useOptions';

interface Props {
  children: React.ReactNode;
}

export const Container = ({ children }: Props) => {
  const {
    options: { catalog_product },
    isFetched,
  } = useOptions();
  const { checkedOnlyZigzinOption, initialize } = useOptionsControl();

  const prev_only_zigzin_option = useRef<boolean>(false);
  const should_update_only_zigzin_option = !checkedOnlyZigzinOption === prev_only_zigzin_option.current;

  useEffect(() => {
    if (isFetched && catalog_product) {
      initialize({ options_data: catalog_product, shipping_fee: catalog_product.shipping_fee });
    }
  }, [isFetched, initialize, catalog_product?.id]);

  useEffect(() => {
    if (should_update_only_zigzin_option && catalog_product) {
      prev_only_zigzin_option.current = checkedOnlyZigzinOption;
      initialize({
        options_data: catalog_product,
        shipping_fee: catalog_product.shipping_fee,
        data_saved: true,
      });
    }
  }, [should_update_only_zigzin_option, initialize]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
